import './ticket_summary_review_view.js.coffee'

Namespace 'Customer.Dashboard'

class Customer.Dashboard.TicketSummaryGoogleMyBusinessReviewView extends Customer.Dashboard.TicketSummaryReviewView
  template: JST['backbone/templates/customer/dashboard/summary/main/body/ticket_summary_google_my_business_review']

  render: ->
    @$el.html @template
      reviewSubject: @_subject()
      subjectLink: @_subjectLink()
      reviewSubjectMetadata: @_subjectMetadata()
    @$el.find('#subject-metadata-separator').hide() if !@_subjectMetadata()
    @_getStars()
    @

  _subject: ->
    return "#{@review.subject} (#{@review.subject_metadata.store_code})" if @review.subject_metadata.store_code
    super()

  _subjectMetadata: ->
    address = @_addressParser().parse(@review.subject_metadata.address) if @review.subject_metadata.address
    return address.toString() if address

  _subjectLink: ->
    @review.subject_metadata.url

  _addressParser: ->
    new Monitoring.Models.SocialContents.GoogleMyBusiness.Parsers.GoogleMyBusinessAddressParser()
